import axios from "axios";
import { API_URL } from "../utils/apiUtils";

export const createGroupService = async (formData) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.post(
      `${API_URL}/group/create-group`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw (
      error.response?.data?.message ||
      "Group Creation failed. Please try again."
    );
  }
};

export const fetchGroupService = async (page, rowsPerPage) => {
  try {
    console.log("im called");
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/group/get-groups`, {
      params: {
        page: page + 1,
        limit: rowsPerPage, // use 'limit' for rows per page
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
export const closeGroupLoanService = async (groupId) => {
  try {
    const token = sessionStorage.getItem("accessToken");

    const response = await axios.put(
      `${API_URL}/group/close-group-loan/${groupId}`,
      {}, // no body needed
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );

    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error closing group loan",
    );
  }
};

export const fetchGroupByIdService = async (id) => {
  try {
    console.log("im called");
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/group/get-group-by-id/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
export const updateGroupService = async (values, id) => {
  try {
    console.log("im called");
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/group/update-group/${id}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
export const fetchGroupCollectionByIdService = async (id) => {
  try {
    console.log("im called");
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/group/get-group-collection/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
export const searchGroupsService = async (
  page,
  rowsPerPage,
  searchQuery,
  isGroupCustomer,
) => {
  const token = sessionStorage.getItem("accessToken");
  try {
    const response = await axios.get(`${API_URL}/group/search-group`, {
      params: {
        page: page + 1,
        limit: rowsPerPage,
        searchQuery: searchQuery,
        isGroupCustomer,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Unable to fetch. Please try again.";
  }
};
export const fetchFullGroupCollectionByIdService = async (id) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/group/get-group-collection-by-search/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
export const fetchFullPigmyGroupCollectionByIdService = async (id) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(
      `${API_URL}/group/get-group-pigmy-collection-by-search/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};

export const updateGroupCollectionsService = async (
  loanId,
  amountToBePaidBy,
  collectionDate,
  interestAmount,
  paidAmount,
  selectedUserData,
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/group/update-collection`,
      {
        amountToBePaidBy,
        collectionDate,
        interestAmount,
        paidAmount,
        selectedUserData,
      },
      {
        params: {
          id: loanId,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data?.loanCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};

export const updateGroupPigmyCollectionsService = async (
  id,
  collectionDate,
  paidAmount,
  selectedUsers,
  selectedData,
) => {
  try {
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.put(
      `${API_URL}/group/update-pigmy-collection`,
      {
        collectionDate,
        paidAmount,
        selectedUsers,
        selectedData,
      },
      {
        params: {
          id: id,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    return response.data?.loanCollection;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
export const checkCustomerGroupService = async (id) => {
  try {
    console.log("im called");
    const token = sessionStorage.getItem("accessToken");
    const response = await axios.get(`${API_URL}/group/check-customer`, {
      params: {
        id, // use 'limit' for rows per page
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || "Error fetching loan collections",
    );
  }
};
